(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__amatoraMenu) return;
    window.__amatoraMenu = true;

    // ── Desplegables de computadora ──
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var t = item.querySelector('[data-nav-toggle]');
      if (t) t.setAttribute('aria-expanded', String(open));
    }
    function closeOthers(except) {
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (it) {
        if (it !== except) setOpen(it, false);
      });
    }
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    document.addEventListener('mouseover', function (e) {
      if (!canHover || !e.target.closest) return;
      var it = e.target.closest('[data-nav-item]');
      if (!it || it.contains(e.relatedTarget)) return;
      clearTimeout(it._amClose);
      closeOthers(it);
      setOpen(it, true);
    });
    document.addEventListener('mouseout', function (e) {
      if (!canHover || !e.target.closest) return;
      var it = e.target.closest('[data-nav-item]');
      if (!it || it.contains(e.relatedTarget)) return;
      it._amClose = setTimeout(function () { setOpen(it, false); }, 140);
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-nav-toggle]');
      if (!t) return;
      var it = t.closest('[data-nav-item]');
      var open = !it.classList.contains('is-open');
      closeOthers(it);
      setOpen(it, open);
    });
    document.addEventListener('focusout', function (e) {
      var it = e.target.closest && e.target.closest('[data-nav-item]');
      if (it && !it.contains(e.relatedTarget)) setOpen(it, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var it = document.querySelector('[data-nav-item].is-open');
      if (!it) return;
      setOpen(it, false);
      var t = it.querySelector('[data-nav-toggle]');
      if (t) t.focus();
    });

    // ── Buscar desde el menú del celular: cierra el menú y abre el buscador ──
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-menu-search]');
      if (!btn) return;
      var dlg = btn.closest('dialog');
      var close = dlg && dlg.querySelector('[data-amatora-close]');
      if (close) close.click();
      setTimeout(function () {
        var trigger = document.querySelector('.amatora-header [data-amatora-open="search-modal"]');
        if (trigger) trigger.click();
      }, 320);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
